import { CSSObject } from '@mui/material';

export const twoScrollBarsLayout: CSSObject & { elements: CSSObject } = {
  // use two-scroll-bars layout (one scrollbar for the menu and one for the content) https://docs.stoplight.io/docs/elements/d536b917a4e1d-layout
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - var(--header-height))',

  elements: {
    flex: '1 0 0',
    overflow: 'hidden'
  }
};
